import Button from '../../common/button.tsx';
import {
  AssetElementFragment,
  CourseStatus,
  UpdateAssetMutation,
} from '../../../apollo/__generated__/graphql.ts';
import Modal from '../../common/modal.tsx';
import RemoveModal from '../../common/remove-modal.tsx';
import { useEffect, useState } from 'react';
import { FetchResult } from '@apollo/client';
import { getDateString } from '../../../utils/common-utils.ts';
import AssetElement from './asset-element.tsx';
import CoursesBrowser from '../../../routes/admin/courses/courses-browser.tsx';

interface IProps {
  elements: readonly AssetElementFragment[];
  onUpdate: (
    updateElements: {
      quizIds?: number[];
      testIds?: number[];
      courseIds?: number[];
    },
    updateText: string,
  ) => Promise<FetchResult<UpdateAssetMutation>> | null;
}

const CoursesTab = ({ elements, onUpdate }: IProps) => {
  const [isModalAdd, setModalAdd] = useState(false);
  const [idToDetach, setIdToDetach] = useState<number | null>(null);
  const [idsToAdd, setIdsToAdd] = useState<number[]>([]);
  const [coursesElements, setCoursesElements] = useState(
    elements.filter((el) => el.course?.id),
  );

  useEffect(() => {
    setCoursesElements(elements.filter((el) => el.course?.id));
  }, [elements]);

  const onClose = () => {
    setModalAdd(false);
    setIdsToAdd([]);
    setIdToDetach(null);
  };
  const update = () => {
    const courseIds = coursesElements
      .map((el) => el.course!.id)
      .filter((id) => id !== idToDetach);

    const successText = idToDetach
      ? 'Course detached'
      : `${idsToAdd.length ? 'Courses' : 'Course'} successfully added to the asset`;
    onUpdate({ courseIds: [...courseIds, ...idsToAdd] }, successText)?.then(
      onClose,
    );
  };

  return (
    <div>
      <Button onClick={() => setModalAdd(true)}>Assign course</Button>

      <div className={'mt-4'}>
        {coursesElements.map((element) => {
          const course = element.course;
          if (course?.id)
            return (
              <AssetElement
                key={element.id}
                name={course.name}
                onClickDetach={() => setIdToDetach(course.id)}
                assignedOn={getDateString(element.createdAt)}
              />
            );
        })}
      </div>
      {!coursesElements.length && <div>No courses yet</div>}

      <Modal
        title={'Assign courses'}
        onClose={onClose}
        fullScreen
        isOpen={isModalAdd}
        description={'Select courses that you want to add to the asset'}
      >
        <Button
          onClick={update}
          disabled={!idsToAdd.length}
          className={'ml-auto mt-2'}
        >
          {idsToAdd.length > 1 ? 'Assign courses' : 'Assign course'}
        </Button>

        <CoursesBrowser
          setSelectedCourses={setIdsToAdd}
          status={CourseStatus.Active}
        />
      </Modal>

      <RemoveModal open={!!idToDetach} onRemove={update} onClose={onClose} />
    </div>
  );
};
export default CoursesTab;
